import {
  bigint,
  decimal,
  index,
  integer,
  jsonb,
  pgTable,
  text,
} from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getNullableIdReference,
} from '../common/utils'
import { properties } from './property'

export const locationHistory = pgTable(
  'location_history',
  {
    ...getBaseFields(),
    entityType: text().notNull(),
    entityId: bigint({ mode: 'number' }).notNull(),
    latitude: decimal({ precision: 10, scale: 8 }).notNull(),
    longitude: decimal({ precision: 11, scale: 8 }).notNull(),
    accuracy: integer(),
    altitude: decimal({ precision: 8, scale: 2 }),
    speed: decimal({ precision: 6, scale: 2 }),
    heading: decimal({ precision: 5, scale: 2 }),
    source: text(),
    metadata: jsonb(),
    propertyId: getNullableIdReference(() => properties.id),
  },
  (table) => [
    ...getBaseIndexes('location_history', table),
    index('location_history_entity_idx').on(
      table.entityType,
      table.entityId,
      table.createdAt,
    ),
  ],
)
